export default __webpack_public_path__ + "static/media/room-kitchen-illustration.0a67782f.png";